import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './ui/dialog';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { X } from 'lucide-react';
import axios from 'axios';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const WaitlistModal = ({ isOpen, onClose }) => {
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email || !name) {
      toast.error('Please fill in all fields');
      return;
    }

    setLoading(true);
    try {
      await axios.post(`${API}/waitlist`, { email, name });
      toast.success('Successfully joined the waitlist!');
      setEmail('');
      setName('');
      onClose();
    } catch (error) {
      console.error('Error joining waitlist:', error);
      toast.error('Failed to join waitlist. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent style={{
        background: '#000000',
        border: '2px solid #00FFD1',
        maxWidth: '500px',
        padding: '40px'
      }}>
        <button
          onClick={onClose}
          style={{
            position: 'absolute',
            top: '16px',
            right: '16px',
            background: 'none',
            border: 'none',
            color: '#FFFFFF',
            cursor: 'pointer',
            padding: '8px'
          }}
          onMouseEnter={(e) => e.target.style.color = '#00FFD1'}
          onMouseLeave={(e) => e.target.style.color = '#FFFFFF'}>
          <X size={24} />
        </button>

        <DialogHeader>
          <DialogTitle style={{
            fontSize: '32px',
            fontWeight: 600,
            color: '#FFFFFF',
            marginBottom: '8px'
          }}>
            Coming Soon
          </DialogTitle>
          <DialogDescription style={{
            fontSize: '18px',
            color: 'rgba(255, 255, 255, 0.85)',
            marginBottom: '24px'
          }}>
            The paper is currently under final review. Join our waitlist to be notified when it's published.
          </DialogDescription>
        </DialogHeader>

        <form onSubmit={handleSubmit} style={{ marginTop: '24px' }}>
          <div style={{ marginBottom: '20px' }}>
            <label style={{
              display: 'block',
              fontSize: '16px',
              fontWeight: 500,
              color: '#FFFFFF',
              marginBottom: '8px'
            }}>
              Name
            </label>
            <Input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Your name"
              style={{
                background: 'rgba(255, 255, 255, 0.1)',
                border: '1px solid rgba(255, 255, 255, 0.25)',
                color: '#FFFFFF',
                padding: '12px 16px',
                fontSize: '16px',
                borderRadius: '0px',
                width: '100%'
              }}
            />
          </div>

          <div style={{ marginBottom: '24px' }}>
            <label style={{
              display: 'block',
              fontSize: '16px',
              fontWeight: 500,
              color: '#FFFFFF',
              marginBottom: '8px'
            }}>
              Email
            </label>
            <Input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="your@email.com"
              style={{
                background: 'rgba(255, 255, 255, 0.1)',
                border: '1px solid rgba(255, 255, 255, 0.25)',
                color: '#FFFFFF',
                padding: '12px 16px',
                fontSize: '16px',
                borderRadius: '0px',
                width: '100%'
              }}
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            style={{
              background: '#00FFD1',
              color: '#000000',
              border: 'none',
              borderRadius: '0px',
              padding: '14px 24px',
              fontSize: '18px',
              fontWeight: 500,
              cursor: loading ? 'not-allowed' : 'pointer',
              transition: 'all 0.4s ease-in-out',
              width: '100%',
              opacity: loading ? 0.6 : 1
            }}
            onMouseEnter={(e) => {
              if (!loading) {
                e.target.style.background = 'rgba(0, 255, 209, 0.1)';
                e.target.style.color = '#00FFD1';
              }
            }}
            onMouseLeave={(e) => {
              if (!loading) {
                e.target.style.background = '#00FFD1';
                e.target.style.color = '#000000';
              }
            }}>
            {loading ? 'Joining...' : 'Join Waitlist'}
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default WaitlistModal;